import { Flex, Modal, Table } from "@mantine/core";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import TableInfoButton from "../../common/Buttons/TableInfoButton";
import TableDeleteButton from "../../common/Buttons/TableDeleteButton";
import CustomPagination from "../../common/CustomPagination";
import AreYouSureModal from "../../common/Modals/AreYouSureModal";
import styled from "styled-components";
import { Contract } from "../../../types/types";
import { deleteNotification } from "../../../utils/useNotification";
import TableEditButton from "../../common/Buttons/TableEditButton";
import { deleteContract, getContractList } from "../../../api/contractApi";
import { formatDateDayMonthYear } from "../../../utils/dateFormats";
import ContractUpdateForm from "./ContractUpdateForm";
import CustomSearchInput from "../../common/Inputs/CustomSearchInput";

const ContractSettingsTable = () => {
  //   const { refetchDepartmentSelectData } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [tableData, setTableData] = useState<any>();
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [itemToDeleted, setItemToDeleted] = useState<any>();

  //for modal
  const [opened, setOpened] = useState(false);
  const [clickedContract, setClickedContract] = useState<any>();
  const [isUpdated, setIsUpdated] = useState<boolean>(false);

  //for filters
  const [searchedName, setSearchedName] = useState<any>();

  const getTableData = async () => {
    try {
      const { data }: any = await getContractList({
        pageNumber: page,
        limit: limit,
        name: searchedName,
      });
      setTableData(data?.data);
      setPage(data?.meta?.page);
      setLimit(data?.meta?.limit);
      setTotalPages(data?.meta?.totalPages);
      setTotalItems(data?.meta?.total);
    } catch (error) {}
  };

  const handleDeleteClick = async (id: string) => {
    try {
      const { data }: any = await deleteContract({ id });
      //   refetchDepartmentSelectData();
      deleteNotification(data?.success);
      const { data: updatedList }: any = await getContractList({
        pageNumber: page,
        limit: limit,
      });
      setTableData(updatedList?.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    if (page) {
      getTableData();
    }
  }, [page, searchedName]);

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            overflowY: "auto",
            height: "422px",
            width: "100%",
            border: "1px solid #D1D5DB",
            borderRadius: "6px",
          }}
        >
          <Flex p={"12px 16px"} justify={"space-between"}>
            <CustomSearchInput
              value={searchedName}
              w={220}
              placeholder="Kontrat Adı"
              onChange={(event: any) => {
                setPage(1);
                setSearchedName(event.currentTarget.value);
              }}
            />
          </Flex>
          <Table
            style={{
              borderCollapse: "separate",
            }}
            verticalSpacing="sm"
          >
            <Table.Thead
              style={{
                background: "#EEF2FF",
              }}
            >
              <Table.Tr>
                <StyledTableTh
                  style={{
                    width: "30%",
                  }}
                >
                  Kontrat İsmi
                </StyledTableTh>
                <StyledTableTh
                  style={{
                    width: "20%",
                  }}
                >
                  Aylık Çalışma Süresi
                </StyledTableTh>

                <StyledTableTh
                  style={{
                    width: "25%",
                  }}
                >
                  Başlangıç Tarihi
                </StyledTableTh>
                <StyledTableTh
                  style={{
                    width: "25%",
                  }}
                >
                  Bitiş Tarihi
                </StyledTableTh>
                <StyledTableTh
                  style={{
                    width: "25%",
                  }}
                ></StyledTableTh>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {tableData?.map((contract: Contract) => (
                <StyledTableTr
                  // onClick={() => {
                  //   navigate(`${location?.pathname}/${contract?._id}`);
                  // }}
                  style={{
                    color: "#111827",
                    fontSize: "16px",
                    fontWeight: "400",
                  }}
                  key={contract?._id}
                >
                  <StyledTableTd>
                    <WidthController>{contract?.name}</WidthController>
                  </StyledTableTd>
                  <StyledTableTd>
                    <WidthController>{contract?.monthlyHours}</WidthController>
                  </StyledTableTd>
                  <StyledTableTd>
                    {contract?.startDate
                      ? formatDateDayMonthYear(contract?.startDate)
                      : "Tarih Yok."}
                  </StyledTableTd>
                  <StyledTableTd>
                    {contract?.endDate
                      ? formatDateDayMonthYear(contract?.endDate)
                      : "Tarih Yok."}
                  </StyledTableTd>
                  <StyledTableTd>
                    <Flex>
                      {/* <TableInfoButton
                            onClick={(e: any) => {
                              e.stopPropagation();
                              navigate(
                                `${location?.pathname}/${contract?._id}`
                              );
                            }}
                          /> */}
                      <TableEditButton
                        onClick={(e: any) => {
                          e.stopPropagation();
                          setClickedContract(contract);
                          setOpened(true);
                        }}
                      />

                      <TableDeleteButton
                        onClick={(e: any) => {
                          e.stopPropagation();
                          setItemToDeleted(contract);
                          setOpenDeleteModal(true);
                        }}
                      />
                    </Flex>
                  </StyledTableTd>
                </StyledTableTr>
              ))}
            </Table.Tbody>
          </Table>
        </div>
        <div
          style={{
            paddingTop: "24px",
          }}
        >
          <CustomPagination
            total={totalPages}
            value={page}
            onChange={setPage}
          />
        </div>
      </div>
      <Modal
        opened={opened}
        title="Kontrat Bilgisi Düzenleme"
        centered
        onClose={() => {
          setOpened(false);
        }}
        withCloseButton={true}
        keepMounted={false}
        key={clickedContract?._id}
      >
        <ContractUpdateForm
          closeModal={() => setOpened(false)}
          contract={clickedContract}
          updateContractList={getTableData}
        />
      </Modal>
      <AreYouSureModal
        opened={openDeleteModal}
        setOpened={setOpenDeleteModal}
        proccessFunc={() => handleDeleteClick(itemToDeleted._id)}
        title="Contractı Sil"
        text="Bu contractı silmek istediğinizden emin misiniz?"
        confirmButtonText="Sil"
        cancelButtonText="Vazgeç"
      />
    </>
  );
};

export default ContractSettingsTable;

const StyledTableTh = styled(Table.Th)`
  color: #4c4c4c;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
`;

const StyledTableTr = styled(Table.Tr)`
  // &:hover {
  //   background: #f1f3f5 !important;
  // }
`;

const StyledTableTd = styled(Table.Td)`
  white-space: wrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const WidthController = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 1; /* kaç satır istiyorsan */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;
